import React, { useContext } from "react";
import {
  getLabelTagInput,
  getLabelTagsWithDescription,
  getLabelTagsWithDynamicInputs,
  getPastMedicalHistorySummary,
} from "../../InspectionSummaries/constructTextFromValues";
import SummaryWrapper from "../../InspectionSummaries/SummaryWrapper";
import { DailyReviewContext } from "../../Doctor/DailyReview/DailyReviewFormProvider";
import {
  knownAllergiesOptions,
  pastMedicalOptions,
  presentIllnessOptions,
} from "../../Options/historyOptions";
import { HistoryOutlined } from "@ant-design/icons";
const DrHistorySummaryDR = () => {
  const { formData } = useContext(DailyReviewContext);

  const constructDrHistorySummaryDR = () => {
    const historySummaryDrItems = [];

    if (getLabelTagsWithDescription(presentIllnessOptions, formData?.history)) {
      historySummaryDrItems.push({
        key: "1",
        label: "Present Illness",
        children: (
          <>
            {getLabelTagsWithDescription(
              presentIllnessOptions,
              formData?.history
            )}
            {getLabelTagsWithDynamicInputs(
              formData?.history?.present_illness_others
            )}
          </>
        ),
      });
    }
    if (getPastMedicalHistorySummary(pastMedicalOptions, formData?.history)) {
      historySummaryDrItems.push({
        key: "2",
        label: "Past Medical History",
        children: getPastMedicalHistorySummary(
          pastMedicalOptions,
          formData?.history
        ),
      });
    }
    if (getLabelTagsWithDescription(knownAllergiesOptions, formData?.history)) {
      historySummaryDrItems.push({
        key: "3",
        label: "Known Allergies",
        children: (
          <>
            {getLabelTagsWithDescription(
              knownAllergiesOptions,
              formData?.history
            )}
            {getLabelTagsWithDynamicInputs(
              formData?.history?.known_allergies_others
            )}
          </>
        ),
      });
    }
    if (formData?.history?.present_complaints) {
      historySummaryDrItems.push({
        key: "4",
        label: "Present Complaints",
        children: getLabelTagInput(
          "Details",
          formData?.history?.present_complaints
        ),
      });
    }
    return historySummaryDrItems;
  };
  const historySummaryItems = constructDrHistorySummaryDR();
  return (
    <div>
      {historySummaryItems.length > 0 && (
        <SummaryWrapper
          items={historySummaryItems}
          title={
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              <HistoryOutlined
                style={{ color: "var(--ant-primary-color)", fontWeight: "bold" }}
              />{" "}
              History
            </span>
          }
        />
      )}
    </div>
  );
};

export default DrHistorySummaryDR;
